import { trackClickAndReserveEvent } from '../tracking/trackingLayer';

const templateElement = document.getElementById('online-reservation-link-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',
  props: {
    articleId: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const openLayer = () => {
      document.dispatchEvent(
        new CustomEvent('ents:online-reservation:open', { detail: { articleId: props.articleId } }),
      );
      // kept for external consumers (e.g. Wishlist)
      document.dispatchEvent(new CustomEvent('ents:hva-modal:open', { detail: { articleId: props.articleId } }));
      trackClickAndReserveEvent();
    };

    return { openLayer };
  },
};
